export default {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};



//////////////////
// WEBPACK FOOTER
// /~/d3-shape/src/symbol/square.js
// module id = X3ZD
// module chunks = 0